import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getNewHomeowner () {
    return axios.get(endpoints.clients + 'new_homeowner/').then((response) => {
      return response.data
    })
  },
  async getContactsAndClients () {
    return axios.get(endpoints.clients).then((response) => {
      return _.orderBy(response.data.filter(c => c.is_new_homeowner === false), 'name_display')
    })
  },
  async createClient (newClient) {
    return axios.post(endpoints.clients, newClient).then((response) => {
      return response.data
    })
  },
  async updateClient (updatedClient) {
    return axios.patch(endpoints.clients + updatedClient.id + '/', updatedClient).then((response) => {
      return response.data
    })
  },
  async toggleClientArchive (client) {
    if (client.archived) {
      client.archived = false
    } else {
      client.archived = true
    }
    return axios.patch(endpoints.clients + client.id + '/', client).then((response) => {
      return response.data
    })
  },
  async getClients (id = null) {
    if (id) {
      id = id + '/'
    } else {
      id = ''
    }
    return axios.get(endpoints.clients + id).then((response) => {
      if (id) {
        return response.data
      } else {
        return response.data.filter(c => c.is_new_homeowner === false )
      }
    })
  },
  async getWorksForClients (id) {
    return axios.get(endpoints.clients + '?works_for=' + id).then((response) => {
      return response.data
    })
  },
  async createClientContact (contact) {
    return axios.post(endpoints.clientContacts, contact).then((response) => {
      return response.data
    })
  },
  async updateClientContact (contact) {
    return axios.patch(endpoints.clientContacts + contact.id + '/', contact).then((response) => {
      return response.data
    })
  },
  async removeClientContact (contact) {
    return axios.delete(endpoints.clientContacts + contact.id + '/').then((response) => {
      return response.data
    })
  },
  async getConnectedClients (contact) {
    return axios.get(endpoints.clientContacts + '?contact=' + contact.id).then((response) => {
      return response.data
    })
  },
  async getClientContacts (id = null) {
    // In this case, `id` is the Client id that you want to filter on
    if (id) {
      return axios.get(endpoints.clientContacts + '?client=' + id).then((response) => {
        return response.data
      })
    } else {
      return axios.get(endpoints.clientContacts).then((response) => {
        return response.data
      })
    }
  },
  async getContacts (id = null) {
    // Contacts (versus clients) are simply a `Contact` record with the `is_client` flag set to FALSE
    if (id) {
      id = id + '/'
      return axios.get(endpoints.clients + id).then((response) => {
        return response.data
      })
    } else {
      return axios.get(endpoints.clients + '?is_client=false&is_vendor=false').then((response) => {
        return response.data
      })
    }
  },
  async getIndividualClients () {
    return axios.get(endpoints.clients + '?is_company=false').then((response) => {
      return response.data
    })
  },
  async getCompanyClients () {
    return axios.get(endpoints.clients + '?is_company=true').then((response) => {
      return response.data
    })
  },
  async getClientInvoices (id) {
    return axios.get(endpoints.invoices + '?bill_to=' + id + '&is_template=false').then((response) => {
      return response.data
    })
  },
  async getClientProjects (id) {
    return axios.get(endpoints.projects + '?owner=' + id).then((response) => {
      return response.data
    })
  },
  async getClientEstimates (id) {
    return axios.get(endpoints.estimates + '?owner=' + id).then((response) => {
      return response.data
    })
  },
  async getConnectedProjects (clientID) {
    return axios.get(endpoints.clients + clientID + '/connected_projects/').then((response) => {
      return response.data
    })
  },
  async clientSearch (search, filter = null, exact) {
    let groupFilter = ''
    if (filter !== null) {
      groupFilter = '&is_company=' + filter
    }

    return axios.get(endpoints.clientSearch + `?name=${search}&last_name=${search}&exact=${exact}` + groupFilter).then((response) => {
      return response.data
    })
  }
}
